import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EquipmentStatus } from 'src/utils/constants/equipment';
import { selectEquipmentQueryOptions } from 'src/store/selectors/equipmentSelectors';
import { loadEquipment } from 'src/store/actions/equipmentsActions';
import EquipmentsList from './EquipmentsList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function selectEquipmentStatus(value) {
  switch (Number(value)) {
    case 0:
      return EquipmentStatus.ACTIVE;
    case 1:
      return EquipmentStatus.SOLD;
    default:
      return EquipmentStatus.ACTIVE;
  }
}

const EquipmentListTabs = () => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const dispatch = useDispatch();
  const queryOpts = useSelector(selectEquipmentQueryOptions);
  const { t } = useTranslation();

  const handleChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
      dispatch(
        loadEquipment({
          ...queryOpts,
          status: selectEquipmentStatus(newValue)
        })
      );
    },
    [setTabIndex, dispatch, queryOpts]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleChange}
        >
          <Tab label={t('COMMON.ACTIVES')} />
          <Tab label={t('COMMON.SOLD')} />
        </Tabs>
      </AppBar>
      <TabPanel value={tabIndex} index={0}>
        <EquipmentsList />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <EquipmentsList />
      </TabPanel>
    </Box>
  );
};

export default EquipmentListTabs;
